import React, { createContext, useState } from "react"

export const BahiaContext = createContext()

export const BahiaProvider = ({ children }) => {
  const [bahias, setBahias] = useState([]) // This will hold the filtered data

  return <BahiaContext.Provider value={{ bahias, setBahias }}>{children}</BahiaContext.Provider>
}
